import React from 'react'
import {
  Box,
  IconButton,
  Select,
  MenuItem,
  Typography,
  Tooltip,
  TextField,
  useTheme
} from '@mui/material'
import {
  ChevronLeftOutlined,
  ChevronRightOutlined,
  KeyboardDoubleArrowRightOutlined,
  KeyboardDoubleArrowLeftOutlined
} from '@mui/icons-material'

const InboxPagination = ({ limit, handleLimitChange, page, length, total, setPage }) => {
  const theme = useTheme()
  const pageCount = Math.ceil(total / limit)

  const handleChange = (e) => {
    setPage(e.target.value)
  }

  const handleSubmit = (e) => {
    if (/[1-9]/.test(e.target.value) && Number(e.target.value) <= pageCount) {
      setPage(Number(e.target.value))
    }

    e.preventDefault()
  }
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1,
        backgroundColor: '#fff',
        border: '1px solid #D7D9E6',
        borderRadius: '8px',
        gap: 1
      }}
    >
      {/* Left Side */}
      <Box display='flex' alignItems='center' gap={1}>
        <Select
          value={limit}
          onChange={handleLimitChange}
          size='small'
          variant='outlined'
          sx={{
            height: 32,
            minWidth: 60,
            borderRadius: 1,
            fontSize: 14
          }}
        >
          {[5, 10, 20, 50].map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </Select>
        <Typography sx={{ fontSize: '13px', fontWeight: 700, lineHeight: '16.38px', color: `${theme.palette.primary.primaryText}` }}>
          Per Page
        </Typography>
      </Box>

      {/* Right Side */}
      <Box display='flex' alignItems='center' gap={1}>
        <Typography sx={{ fontSize: '13px', fontWeight: 700, lineHeight: '16.38px', color: `${theme.palette.primary.primaryText}` }}>
          {`${limit * (page - 1) + 1}-${limit * page - (limit - length)} of ${total}`}
        </Typography>

        <Tooltip title='First page'>
          <span>
            <IconButton
              size='small'
              onClick={() => setPage(1)}
              disabled={page === 1}
              sx={{ height: 32, width: 32 }}
            >
              <KeyboardDoubleArrowLeftOutlined fontSize='small' />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title='Previous page'>
          <span>
            <IconButton
              size='small'
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
              sx={{ height: 32, width: 32 }}
            >
              <ChevronLeftOutlined fontSize='small' />
            </IconButton>
          </span>
        </Tooltip>

        <TextField
          size='small'
          value={page}
          onChange={handleChange}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}
          sx={{
            width: 50,
            height: 32,
            input: {
              p: '6px 8px',
              textAlign: 'center',
              fontSize: 14
            }
          }}
        />

        <Typography sx={{ fontSize: '13px', fontWeight: 700, lineHeight: '16.38px', color: `${theme.palette.primary.primaryText}` }}>
          {`Of ${pageCount}`}
        </Typography>

        <Tooltip title='Next page'>
          <span>
            <IconButton
              size='small'
              onClick={() => setPage(Number(page) + 1)}
              disabled={page === pageCount}
              sx={{ height: 32, width: 32 }}
            >
              <ChevronRightOutlined fontSize='small' />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title='Last page'>
          <span>
            <IconButton
              size='small'
              onClick={() => setPage(pageCount)}
              disabled={page === pageCount}
              sx={{ height: 32, width: 32 }}
            >
              <KeyboardDoubleArrowRightOutlined fontSize='small' />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>
  )
}

export default InboxPagination
